// extracted by mini-css-extract-plugin
module.exports = {"container":"i_DU","dark":"i_DV","light":"i_DW","checked":"i_DX","label":"i_DY","indicator":"i_DZ","squared":"i_Da","knobs":"i_Db","knobs-checked":"i_Dc"};